export enum Time {
  DATE = 86400000,
  HOURS = 3600000,
  MINUTES = 60000,
  SECONDS = 1000,
}
